<div class="c-title">
  {{ title }}
</div>